import React, { useState, useRef, useEffect } from "react";
import order from "../../../../../../images/products/order-delivered.jpg";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import axios from "axios";

const Groceryorderplaced = ({ orderId: propOrderId }) => {
    const platformCharge = 1;
    const [orderData, setOrderData] = useState({});
    const [loading, setLoading] = useState(false);
    const [bannerData, setBannerData] = useState(null);
    const [error, setError] = useState("");

    const printRef = useRef();

    const orderId = propOrderId || localStorage.getItem("orderId");
    const vendorId = localStorage.getItem("vendorId");

    useEffect(() => {
        if (!orderId) {
            console.warn("⚠️ No orderId found, skipping fetch.");
            return;
        }

        const fetchOrderDetails = async () => {
            try {
                const authToken = localStorage.getItem("authToken");
                if (!authToken) {
                    console.error("❌ No auth token found in localStorage");
                    return;
                }

                const response = await axios.get(
                    `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/grocery/get/${orderId}`,
                    {
                        headers: {
                            Authorization: `Bearer ${authToken}`,
                            "Content-Type": "application/json",
                        },
                    }
                );

                if (response.status === 200) {
                    setOrderData(response.data);
                }
            } catch (error) {
                console.error("❌ Failed to fetch order details:", error);
            }
        };

        fetchOrderDetails();
    }, [orderId]);

    // ✅ Fetch banner
    useEffect(() => {
        if (!vendorId) return;
        const source = axios.CancelToken.source();

        (async () => {
            try {
                setLoading(true);
                const { data } = await axios.get(
                    `https://backend.maamaas.com/food/banner/vendor/${vendorId}`,
                    { cancelToken: source.token }
                );

                setBannerData({
                    ...data,
                    companyName: data.companyName || "No Name",
                });
                setError("");
            } catch (err) {
                if (!axios.isCancel(err)) {
                    setError("Could not load banner details.");
                }
            } finally {
                setLoading(false);
            }
        })();

        return () => source.cancel();
    }, [vendorId]);

    const handlePrint = () => {
        const printContent = printRef.current.innerHTML;
        const originalContent = document.body.innerHTML;
        document.body.innerHTML = printContent;
        window.print();
        document.body.innerHTML = originalContent;
        window.location.reload();
    };

    const handleDownload = () => {
        const receipt = document.querySelector(".three");
        const originalStyle = {
            height: receipt.style.height,
            overflowY: receipt.style.overflowY,
        };
        receipt.style.height = "auto";
        receipt.style.overflowY = "visible";

        html2canvas(receipt, { scale: 2 }).then((canvas) => {
            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPDF("p", "mm", "a4");
            const imgWidth = 210;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;

            pdf.addImage(imgData, "PNG", 0, 10, imgWidth, imgHeight);
            pdf.save("Payment_Receipt.pdf");

            receipt.style.height = originalStyle.height;
            receipt.style.overflowY = originalStyle.overflowY;
        });
    };

    const {
        subtotal = 0,
        cgst = 0,
        sgst = 0,
        platformFeeAmount = 0,
        total = 0,
        orderItems = [],
    } = orderData || {};

    return (
        <div
            className="paymentdata-screen"
            style={{ marginTop: "-40px", marginLeft: "0px", scrollbarWidth: "none" }}
        >
            <div
                ref={printRef}
                className="three"
                style={{
                    height: "520px",
                    background: "rgb(177, 93, 198)",
                    borderRadius: "10px",
                    overflowY: "auto",
                    scrollbarWidth: "none",
                }}
            >
                <div className="paymentpage">
                    <img
                        src={order}
                        alt="image1"
                        style={{
                            height: "50px",
                            borderRadius: "50%",
                            marginLeft: "0px",
                            marginTop: "20px",
                        }}
                    />
                    <h3
                        style={{
                            color: "#fff",
                            marginTop: "30px",
                            marginLeft: "20px",
                        }}
                    >
                        Payment successful!!!
                    </h3>
                </div>

                <hr style={{ border: "1px solid black" }} />
                <h5 className="house">{bannerData?.companyName || "MAAMAAS"}</h5>

                <div
                    className="four row paymentdata-screensrw"
                    style={{ marginLeft: "9px", marginTop: "20px" }}
                >
                    <div
                        style={{ color: "#fff", fontSize: "18px" }}
                        className="col-lg-6 p list1"
                    >
                        <dt style={{ minWidth: "150px" }}>Order ID</dt>
                        <dd style={{ minWidth: "30px" }}>:</dd>
                        <dd
                            style={{
                                minWidth: "100px",
                                color: "#000",
                                fontWeight: "bold",
                            }}
                        >
                            {orderData.orderId}
                        </dd>
                    </div>

                    <div
                        style={{ color: "#fff", fontSize: "18px" }}
                        className="col-lg-6 p list1"
                    >
                        <dt style={{ minWidth: "150px" }}>Date</dt>
                        <dd style={{ minWidth: "30px" }}>:</dd>
                        <dd
                            style={{
                                minWidth: "100px",
                                color: "#000",
                                fontWeight: "bold",
                            }}
                        >
                            {orderData.orderDateTime
                                ? new Date(orderData.orderDateTime).toLocaleDateString("en-GB")
                                : new Date().toLocaleDateString("en-GB")}
                        </dd>
                    </div>

                    <div
                        style={{ color: "#fff", fontSize: "18px" }}
                        className="col-lg-6 p list1"
                    >
                        <dt style={{ minWidth: "150px" }}>Payment Method</dt>
                        <dd style={{ minWidth: "30px" }}>:</dd>
                        <dd
                            style={{
                                minWidth: "100px",
                                color: "#000",
                                fontWeight: "bold",
                            }}
                        >
                            {orderData.paymentMethod || "N/A"}
                        </dd>
                    </div>
                    <div
                        style={{ color: "#fff", fontSize: "18px" }}
                        className="col-lg-6 p list1"
                    >
                        <dt style={{ minWidth: "150px" }}>Time</dt>
                        <dd style={{ minWidth: "30px" }}>:</dd>
                        <dd
                            style={{
                                minWidth: "100px",
                                color: "#000",
                                fontWeight: "bold",
                            }}
                        >
                            {orderData.orderDateTime
                                ? new Date(orderData.orderDateTime).toLocaleTimeString("en-GB", {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    second: "2-digit",
                                })
                                : new Date().toLocaleTimeString("en-GB", {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    second: "2-digit",
                                })}
                        </dd>
                    </div>

                </div>

                <hr style={{ border: "1px solid black" }} />

                {loading ? (
                    <p>Loading...</p>
                ) : Array.isArray(orderItems) && orderItems.length > 0 ? (
                    <>
                        <table
                            className="order-table"
                            style={{ marginLeft: "10px", fontSize: "20px", fontWeight: "bold" }}
                        >
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Item</th>
                                    <th>Category</th>
                                    <th>Qty</th>
                                    <th>Price (₹)</th>
                                    <th>Total (₹)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {orderItems.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{item.groceryItemName}</td>
                                        <td>{item.groceryCategory}</td>
                                        <td>{item.quantity}</td>
                                        <td>{item.groceryPrice?.toFixed(2) ?? "0.00"}</td>
                                        <td>
                                            {(item.groceryPrice * item.quantity).toFixed(2) ?? "0.00"}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        <hr style={{ border: "1px dashed black" }} />

                        {/* Totals */}
                        <div style={{ marginTop: "20px" }}>
                            <dl
                                style={{
                                    display: "flex",
                                    justifyContent: "end",
                                    marginRight: "30px",
                                    fontSize: "15px",
                                }}
                            >
                                <dt style={{ minWidth: "200px", color: "#fff", fontSize: "17px" }}>
                                    Sub Total
                                </dt>
                                <dt style={{ minWidth: "60px", fontSize: "17px" }}>
                                    ₹{subtotal.toFixed(2)}
                                </dt>
                            </dl>
                        </div>

                        <div>
                            <dl
                                style={{
                                    display: "flex",
                                    justifyContent: "end",
                                    marginRight: "30px",
                                    fontSize: "15px",
                                }}
                            >
                                <dt style={{ minWidth: "200px", color: "#fff", fontSize: "17px" }}>
                                    Platform Fee
                                </dt>
                                <dt style={{ minWidth: "60px", fontSize: "17px" }}>
                                    ₹{platformFeeAmount.toFixed(2)}
                                </dt>
                            </dl>
                        </div>

                        <div>
                            <dl
                                style={{
                                    display: "flex",
                                    justifyContent: "end",
                                    marginRight: "30px",
                                    fontSize: "15px",
                                }}
                            >
                                <dt style={{ minWidth: "200px", color: "#fff", fontSize: "17px" }}>
                                    CGST
                                </dt>
                                <dt style={{ minWidth: "60px", fontSize: "17px" }}>₹{cgst.toFixed(2)}</dt>
                            </dl>
                        </div>

                        <div>
                            <dl
                                style={{
                                    display: "flex",
                                    justifyContent: "end",
                                    marginRight: "30px",
                                    fontSize: "15px",
                                }}
                            >
                                <dt style={{ minWidth: "200px", color: "#fff", fontSize: "17px" }}>
                                    SGST
                                </dt>
                                <dt style={{ minWidth: "60px", fontSize: "17px" }}>₹{sgst.toFixed(2)}</dt>
                            </dl>
                        </div>

                        <hr style={{ border: "1px dashed black" }} />
                        <div>
                            <dl
                                style={{
                                    display: "flex",
                                    justifyContent: "end",
                                    marginRight: "30px",
                                    fontSize: "15px",
                                }}
                            >
                                <dt style={{ minWidth: "200px", color: "#fff", fontSize: "23px" }}>
                                    Grand Total
                                </dt>
                                <dt style={{ minWidth: "60px", fontSize: "23px" }}>₹{total.toFixed(2)}</dt>
                            </dl>
                        </div>
                    </>
                ) : (
                    <p>No order data available.</p>
                )}

                <div className="thankyou">
                    <h5
                        style={{
                            color: "#fff",
                            fontWeight: "bold",
                            fontSize: "24px",
                        }}
                    >
                        Thank You!!! Visit Again.....
                    </h5>
                    <p style={{ color: "#ddd", fontSize: "18px" }}>www.maamaas.com</p>
                    <div
                        className="buttons-data"
                        style={{ display: window.innerWidth <= 768 ? "none" : "block" }}
                    >
                        <button className="pdfbutton" onClick={handlePrint}>
                            Print
                        </button>
                        <button className="pdfbutton" onClick={handleDownload}>
                            ⬇️Download
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Groceryorderplaced;
